import { ValueType } from 'modules/queryBuilder/legacyQueryBuilder/types';
import { valueTypeLabels } from '../constants';

export const createValueTypeDropdownOption = (valueType: ValueType) => ({
  value: valueType,
  text: valueTypeLabels[valueType],
});
